module.exports = "<div class=pg-filter-box> <div class=pg-filter></div> <input class=pg-filter-input /> </div>";